import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PowerBIEmbedModule } from 'powerbi-client-angular';

import { ReportViewerModalComponent } from './report-viewer-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule } from 'app/components/icons';
import { CoreDirectivesModule } from '@core/directives/directives';

@NgModule({
  declarations: [ReportViewerModalComponent],
  imports: [CommonModule, PowerBIEmbedModule, TranslateModule, IconsModule, CoreDirectivesModule],
  exports: [PowerBIEmbedModule, ReportViewerModalComponent]
})
export class ReportViewerModalModule {}
